interface UsedCard {
    stripe_customer_id: string;
    payment_method_id: string;
    last4: string;
    use_old_card: boolean;
}

interface Header {
    name: string;
    value_with_a_single_line: string;
    value_with_multiple_lines: string;
}

export class PayChargePopupScreenData {
    title: string;
    view: string;
    number_of_extra_users: number;
    tax: number;
    tax_name: string;
    tax_imposed: number;
    payment_method: string;
    payment_file: File;
    used_card: UsedCard;
    file_input_key: number;
    file_input_error: boolean;
    message_listener: any;
    error_message: string;
    headers: Header[];
    selected_charge_for_pay_charge_popup: any;

    constructor() {
        this.title = "Cargando...";
        this.view = 'loading';
        this.number_of_extra_users = 1;
        this.tax = 21;
        this.tax_name = "IVA";
        this.tax_imposed = 21;
        this.payment_method = 'transfer';
        this.payment_file = null;
        this.used_card = {
            stripe_customer_id: null,
            payment_method_id: null,
            last4: null,
            use_old_card: false,
        };
        this.file_input_key = 0;
        this.file_input_error = false;
        this.message_listener = null;
        this.error_message = null;
        this.headers = [
            {
                name: "Concepto",
                value_with_a_single_line: "invoice_concept",
                value_with_multiple_lines: "concept",
            },
            {
                name: "Cantidad",
                value_with_a_single_line: "invoice_quantity",
                value_with_multiple_lines: "quantity",
            },
            {
                name: "Precio (sin impuestos)",
                value_with_a_single_line: "charge_amount",
                value_with_multiple_lines: "amount",
            },
        ];
        this.selected_charge_for_pay_charge_popup = null;
    }
}
